@if (memory) {
    <main class="mediumContainer">
        <div class="d-flex flex-row">
            <button [routerLink]="['/timeline', this.timelineId]" aria-label="Back to timeline" mat-icon-button
                    matTooltip="Back">
                <mat-icon>keyboard_backspace</mat-icon>
            </button>
        </div>
        @if (!memory.duplication_in_progress) {
            <div class="d-flex flex-row flex-space-between pb-10 flex-col-mobile">
                <div class="flex-col">
                    <h1 class="my-0">{{ memory.title }}</h1>
                </div>
                @if ((permission == 'View, Comment and Add' || permission == 'Add but not View or Comment') && !this.user.role.raa_is_limited) {
                    <div class="flex-row gap10 justify-content-end fabRow">
                        @if (reOrder) {
                            <button (click)="saveReorder()" (keyup.enter)="saveReorder()" [disabled]="orderLoading"
                                    aria-label="Save Memory Order"
                                    class="mat-elevation-z2"
                                    color="primary"
                                    mat-raised-button matTooltip="Save Memory Order">
                                Save Order
                                @if (orderLoading) {
                                    <mat-icon matSuffix>
                                        <mat-spinner color="primary"></mat-spinner>
                                    </mat-icon>
                                }
                            </button>
                            <button (click)="refresh()" (keyup.enter)="refresh()" [disabled]="orderLoading"
                                    aria-label="Cancel Re-order"
                                    class="mat-elevation-z2"
                                    color="warn"
                                    mat-mini-fab matTooltip="Cancel Re-order">
                                <mat-icon>cancel</mat-icon>
                            </button>
                        }
                        @if (!reOrder) {
                            <button (click)="newMedia()" (keyup.enter)="newMedia()" aria-label="Add Memory"
                                    class="mat-elevation-z2"
                                    color="primary"
                                    mat-mini-fab matTooltip="Add Memory">
                                <mat-icon>
                                    add_photo_alternate
                                </mat-icon>
                            </button>
                            <button (click)="recordMedia()" (keyup.enter)="recordMedia()"
                                    aria-label="Record New Memory"
                                    class="mat-elevation-z2"
                                    color="primary" mat-mini-fab matTooltip="Record New Memory">
                                <mat-icon>
                                    perm_camera_mic
                                </mat-icon>
                            </button>

                            @if (this.user.role.role_type == 'adult' || this.user.role.role_type == 'admin' && !this.user.role.raa_is_limited) {
                                <button (click)="duplicateAlbum()" (keyup.enter)="duplicateAlbum()"
                                        aria-label="Duplicate Album" class="mat-elevation-z2" color="primary"
                                        mat-mini-fab matTooltip="Duplicate Album">
                                    <mat-icon>
                                        filter_none
                                    </mat-icon>
                                </button>
                            }
                            @if (memory.media && memory.media.length > 1) {
                                <button (click)="initReOrder()" (keyup.enter)="initReOrder()"
                                        aria-label="Re-Order Memories"
                                        class="mat-elevation-z2"
                                        color="primary"
                                        mat-mini-fab matTooltip="Re-order Memories">
                                    <mat-icon>open_with</mat-icon>
                                </button>
                            }
                            @if (this.user.role.can_permanently_delete) {
                                <button (click)="deleteAlbum()" (keyup.enter)="deleteAlbum()"
                                        aria-label="Permanently Delete Album"
                                        class="mat-elevation-z2"
                                        color="warn"
                                        mat-mini-fab matTooltip="Permanently Delete Album">
                                    <mat-icon>delete_forever</mat-icon>
                                </button>
                            }
                        }
                    </div>
                }
            </div>
        }
        @if (!memory.duplication_in_progress) {
            <div class="memoryContainer">
                <div>
                    <div>
                        @if (loading) {
                            <div class="flex-row justify-content-center w-100">
                                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                            </div>
                        }
                        @if (!loading && mediaLoaded && memory.media && memory.media.length > 0) {
                            <div (cdkDropListDropped)="changeOrder($event)" [cdkDropListDisabled]="!reOrder"
                                 [cdkDropListOrientation]="'mixed'"
                                 cdkDropList
                                 class="picsContainer draglist">
                                @for (file of memory.media; track file; let i = $index) {
                                    <mat-card cdkDrag class="dragbox clickable imageCard">
                                        <div *cdkDragPlaceholder class="dragPlaceholder"></div>
                                        @if (reOrder) {
                                            <button cdkDragHandle class="dragIcon" color="primary"
                                                    mat-raised-button
                                                    matTooltip="Drag To Change Order">
                                                <mat-icon>drag_indicator</mat-icon>
                                            </button>
                                        }
                                        <app-media-display (viewImage)="viewImage(i)" [file]="file" [small]="true"
                                                           aria-label="View Media"></app-media-display>
                                        <mat-card-header (click)="viewImage(i)" (keyup.enter)="viewImage(i)"
                                                         class="pb-16">
                                            <mat-card-title>{{ file.title | ellipsis:40 }}</mat-card-title>
                                            @if (file.description) {
                                                <mat-card-subtitle>{{ file.description  | ellipsis:65 }}
                                                </mat-card-subtitle>
                                            }
                                        </mat-card-header>
                                    </mat-card>
                                }
                            </div>
                        } @else if (!loading && mediaLoaded && count === 0 && memory.media?.length === 0) {
                            <p>Looks like no memories are in this album yet!</p>
                        }
                        <mat-paginator (page)="handlePageEvent($event)" [class.hidden]="reOrder" [hidden]="reOrder"
                                       [hidePageSize]='true'
                                       [length]="count"
                                       [pageSize]="limit"
                                       aria-label="Select page"></mat-paginator>
                    </div>
                </div>
                <div class="d-flex flex-col gap-15">
                    <mat-card>
                        <mat-card-header class="flex-space-between">
                            <mat-card-title class="f-20">Album Details</mat-card-title>
                        </mat-card-header>
                        <mat-card-content class="mt-10">
                            @if (memory.description) {
                                <b>Description:</b>
                                <p class="mt-5">{{ memory.description }}</p>
                            }
                            @if (memory.attendees) {
                                <b>Who was there:</b>
                                <p class="mt-5">{{ memory.attendees }}</p>
                            }
                            @if (memory.date) {
                                <b>When it happened:</b>
                                <p class="mt-5">{{ memory.date| date:'mediumDate' }}</p>
                            }
                            @if (memory.creator && memory.creator.id && (this.authService.getDisplayName(memory.creator) != '')) {
                                <div class="flex-col mb-10">
                                    <b class="mb-10">Created By:</b>
                                    <mat-chip (click)="viewProfile(memory.creator.id)"
                                              (keyup.enter)="viewProfile(memory.creator.id)"
                                              [attr.aria-label]="user.role.can_access_profiles ? [(memory.creator| nameDisplay) + ': Click to view profile'] : []"
                                              [class.clickable]="user.role.can_access_profiles"
                                              class="smChip w-content">
                                        @if (memory.creator.photo) {
                                            <img [alt]="(memory.creator | nameDisplay) + ': Click to view profile'"
                                                 [src]="memory.creator.thumbnail|| memory.creator.photo"
                                                 fetchPriority="low"
                                                 loading="lazy"
                                                 matChipAvatar/>
                                        }
                                        {{ memory.creator| nameDisplay }}
                                    </mat-chip>
                                </div>
                            }
                            @if (this.tags && this.tags.length > 0) {
                                <b class="mb-0">Tags:</b>
                                <mat-chip-listbox>
                                    @for (tag of this.tags; track tag) {
                                        <mat-chip class="smChip" color="primary">
                                            {{ tag.name }}
                                        </mat-chip>
                                    }
                                </mat-chip-listbox>
                            }
                        </mat-card-content>
                        @if ((permission == 'View, Comment and Add' || this.user.role.role_type == 'admin') && !this.user.role.raa_is_limited && this.canEdit) {
                            <mat-card-actions align="end">
                                <button (click)="editDetails()" (keyup.enter)="editDetails()"
                                        color="primary" mat-raised-button>Edit
                                </button>
                            </mat-card-actions>
                        }
                    </mat-card>
                    @if (googleLoaded && memory.latitude && memory.longitude && allowsLocation) {
                        <mat-card class="overflow-hidden">
                            <mat-card-header (click)="locationExpanded = !locationExpanded"
                                             (keydown.enter)="locationExpanded = !locationExpanded"
                                             (keydown.space)="$event.preventDefault(); locationExpanded = !locationExpanded"
                                             [attr.aria-expanded]="locationExpanded"
                                             [attr.aria-label]="!locationExpanded ? 'Expand Location Section' : 'Hide Location Section'"
                                             class="mb-10 flex-space-between clickable"
                                             role="button"
                                             tabindex="0">
                                <mat-card-title>Location</mat-card-title>
                                @if (!locationExpanded) {
                                    <mat-icon>
                                        keyboard_arrow_down
                                    </mat-icon>
                                }
                                @if (locationExpanded) {
                                    <mat-icon>
                                        keyboard_arrow_up
                                    </mat-icon>
                                }
                            </mat-card-header>
                            <mat-accordion>
                                <mat-expansion-panel [expanded]="locationExpanded" hideToggle>
                                    <google-map [attr.aria-label]="'Location of memory: ' + memory.address "
                                                [center]="{lat: memory.latitude, lng: memory.longitude}"
                                                [options]="{ mapTypeControl: false, scaleControl: false, draggable: false, scrollwheel: false,  disableDefaultUI: true}"
                                                [zoom]="14"
                                                height="300px" mat-card-image
                                                tabindex="-1"/>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </mat-card>
                    }
                    @if ((permission == 'View and Comment' || permission == 'View, Comment and Add') && allowsComments) {
                        <mat-card>
                            <mat-card-header (click)="commentsExpanded = !commentsExpanded"
                                             (keydown.enter)="commentsExpanded = !commentsExpanded"
                                             (keydown.space)="$event.preventDefault(); commentsExpanded = !commentsExpanded"
                                             [attr.aria-expanded]="commentsExpanded"
                                             [attr.aria-label]="!commentsExpanded ? 'Expand Comments Section' : 'Hide Comments Section'"
                                             class="mb-10 clickable flex-space-between"
                                             role="button"
                                             tabindex="0">
                                <mat-card-title>Comments</mat-card-title>
                                @if (!commentsExpanded) {
                                    <mat-icon>
                                        keyboard_arrow_down
                                    </mat-icon>
                                }
                                @if (commentsExpanded) {
                                    <mat-icon>
                                        keyboard_arrow_up
                                    </mat-icon>
                                }
                            </mat-card-header>
                            <mat-accordion>
                                <mat-expansion-panel [expanded]="commentsExpanded"
                                                     hideToggle>
                                    <app-comments (comment)="sendComment($event)" [comments]="this.comments"
                                                  [mediaComment]="false"
                                                  [reLoading]="commentsLoading"></app-comments>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </mat-card>
                    }
                </div>
            </div>
        }
    </main>
}

@if (!memory || memory.duplication_in_progress) {
    <div class="centerLoading flex-col text-center">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        @if (memory?.duplication_in_progress) {
            <p class="errorMsg">Memories for this album are being duplicated at the
                moment,<br> please
                check back soon to see the full album</p>
        }
    </div>
}
